// @ts-expect-error module not typed
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
import styled from 'foundations-theming/utils';
import { useLayoutEffect, useRef } from 'react';
import { usePopOutEditorState } from '../hooks/usePopOutEditorState';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
const ModalInner = styled.div.withConfig({
  displayName: "EditorModal__ModalInner",
  componentId: "xwai3b-0"
})([".popout-editor-teleporter{padding:", ";position:relative;width:100%;height:100%;display:flex;flex-direction:column;color:", ";}"], ({
  theme
}) => `${theme.space['1500']} ${theme.space['1700']}`, ({
  theme
}) => theme.color['fill-accent-neutral-default']);
const _EditorModal = ({
  editorKey = 'default'
}) => {
  const targetRef = useRef(null);
  const {
    isOpen,
    key,
    setRef
  } = usePopOutEditorState(editorKey);
  useLayoutEffect(() => {
    const shouldUpdateRef = isOpen && key === editorKey;
    if (shouldUpdateRef) {
      setRef(targetRef.current);
    }
    return () => {
      if (shouldUpdateRef) setRef(null);
    };
  }, [isOpen, setRef, key, editorKey]);
  if (isOpen) {
    return /*#__PURE__*/_jsx(Modal, {
      use: "lightbox",
      children: /*#__PURE__*/_jsx(ModalInner, {
        ref: targetRef
      })
    });
  } else {
    return null;
  }
};
_EditorModal.displayName = 'EditorModal';
export const EditorModal = provideThreadView(_EditorModal);